import { el } from '../core/dom.js';
import { openModal } from './modal.js';

/**
 * In-app confirmation (instead of the browser's window.confirm).
 * Resolves true on confirm, false on cancel, Escape, the × button or the backdrop.
 * The safe choice (cancelLabel) has focus first.
 * @param {{ title: string, body?: string, confirmLabel?: string, cancelLabel?: string }} opts
 * @returns {Promise<boolean>}
 */
export function confirmDialog(opts) {
  const options = opts || {};
  return new Promise((resolve) => {
    let settled = false;
    const previous = typeof document !== 'undefined' ? document.activeElement : null;
    const keep = el('button', { type: 'button', class: 'btn btn-ghost' }, options.cancelLabel || 'Cancel');
    const go = el('button', { type: 'button', class: 'btn btn-primary' }, options.confirmLabel || 'Confirm');
    const body = el('div', { class: 'confirm-dialog' },
      options.body ? el('p', { class: 'confirm-dialog-text' }, String(options.body)) : null,
      el('div', { class: 'confirm-dialog-actions' }, keep, go));

    function finish(value) {
      if (settled) return;
      settled = true;
      resolve(value);
      if (previous && typeof previous.focus === 'function') previous.focus();
    }

    const modal = openModal({
      title: String(options.title || 'Are you sure?'),
      body,
      className: 'modal-confirm',
      onClose: () => finish(false),
    });
    keep.addEventListener('click', () => { finish(false); modal.close(); });
    go.addEventListener('click', () => { finish(true); modal.close(); });
    keep.focus();
  });
}
